import { useAuthContext } from 'contexts/auth';
import RoleService from 'services/roleService';

const useRoleService = () => {
  const { roles = [] } = useAuthContext();
  return new RoleService(roles);
};

export default useRoleService;
